import styled from 'styled-components';
import BgConlicitantes from 'assets/images/fundo_login.png';

export const Group = styled.div.attrs({
  className: 'form-group',
})``;

export const Fundo = styled.div`
  /* max-width: 1280px; */
  margin: 0 auto;

  .bg-conlicitantes {
    background-image: url('${BgConlicitantes}');
    background-position: center top;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #360b46;
  }

  .fundo {
    height: 97vh;
  }

  h3 {
    color: #21354a;
    font-weight: bold;
  }

  .message-card {
    background-color: #2969ff0f;
    border-radius: 8px;

    span {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .text-conlicitantes {
    color: #ffaa09;
    font-size: 30px;
    font-weight: bold;
  }
  .nova-lei {
    color: #fff;
    font-size: 20px;
  }

  .conlicitantes {
    background-color: #9f28ea;
    color: #fff;
    border: 1px solid #9f28ea;
    border-radius: 100px;
    color: #fff;
    position: absolute;
    top: 70%;
    left: 60%;
    transform: translate(-50%, -50%);
  }

  .banner-login {
    max-width: 533px;
    max-height: 700px;
    border-radius: 21px;
    box-shadow: 0px 4px 18.1px 0px rgba(134, 139, 148, 1);
  }

  .rounded {
    border-radius: 30px !important;
  }

  @media screen and (max-width: 768px) {
    .conlicitantes {
      top: 80%;
    }
  }

  @media screen and (max-width: 576px) {
    .form-login {
      background-color: unset !important;
      box-shadow: none !important;
      border-radius: none !important;
    }

    .banner-login {
      width: 100%;
    }
  }

  .label span {
    background-color: #921174;
    width: 112.23;
  }

  .container {
    padding: 2rem;
    border-radius: 1rem;
  }

  @media screen and (min-width: 1920px) {
    .text-conlicitantes {
      color: #ffaa09;
      font-size: 30px;
      font-weight: bold;
      margin-top: 20px;
      padding-left: 60px;
    }
  }
`;
